import { render, staticRenderFns } from "./RefusalModal.vue?vue&type=template&id=3a13e279&scoped=true"
import script from "./RefusalModal.vue?vue&type=script&lang=js"
export * from "./RefusalModal.vue?vue&type=script&lang=js"
import style0 from "./RefusalModal.vue?vue&type=style&index=0&id=3a13e279&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a13e279",
  null
  
)

export default component.exports